import { useEffect, useState } from "react";

const useLoadProducts = (): Record<string, string> => {
  const [images, setImages] = useState<Record<string, string>>({});

  useEffect(() => {
    try {
      const imageContext = require.context(
        "../assets/images/products",
        false,
        /\.(png|jpe?g|svg|gif)$/
      );

      const loadedImages: Record<string, string> = {};

      imageContext.keys().forEach((key) => {
        const fileName = key.replace("./", "");
        loadedImages[fileName] = imageContext(key);
      });

      setImages(loadedImages);
    } catch (error) {
      console.error("Failed to load images:", error);
    }
  }, []);

  return images;
};

export { useLoadProducts };
